module.exports = __webpack_public_path__ + "img/T1.9ca1c295.png";